import React from 'react';
import { Form, Button, Avatar, Popconfirm } from '@douyinfe/semi-ui';
import { IconDelete, IconPlus } from '@douyinfe/semi-icons';
import ImageSelector from '../../../ImageSelector';
import { SingleTextStyleForm } from '../../components/SingleText';
import { config } from './config';

export const DanmakuStyleForm = ({ data = {}, onChange }) => {
    const defaultData = {
        ...config.defaultProps
    };

    const handleDanmakuChange = (index, field, value) => {
        const newDanmakus = [...(data.danmakus || defaultData.danmakus)];
        newDanmakus[index] = { ...newDanmakus[index], [field]: value };
        data.danmakus = newDanmakus
        onChange?.({ ...data, danmakus: newDanmakus });
    };

    const addDanmaku = () => {
        const newDanmakus = [...(data.danmakus || defaultData.danmakus)];
        const newDanmaku = {
            text: '新弹幕文本',
            avatar: '',
            textColor: '#fff',
            fontSize: 18,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            speed: 10
        };
        newDanmakus.push(newDanmaku);
        data.danmakus = newDanmakus
        onChange?.({ ...data, danmakus: newDanmakus });
    };

    const removeDanmaku = (index) => {
        const newDanmakus = [...(data.danmakus || defaultData.danmakus)];
        newDanmakus.splice(index, 1);
        if (newDanmakus.length === 0) {
            newDanmakus.push({
                text: '弹幕文本',
                avatar: '',
                textColor: '#fff',
                fontSize: 18,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                speed: 10
            });
        }
        data.danmakus = newDanmakus
        const newData = { ...data, danmakus: newDanmakus };
        onChange?.(newData);
    };

    return (
        <div style={{ padding: '16px' }}>
            <div style={{ marginBottom: '12px', fontWeight: 600 }}>弹幕列表</div>
            {(data.danmakus || defaultData.danmakus).map((danmaku, index) => (
                <div key={`danmaku-${index}`} style={{ marginBottom: '16px', position: 'relative', borderBottom: index < (data.danmakus || defaultData.danmakus).length - 1 ? '1px solid var(--semi-color-border)' : 'none', paddingBottom: '16px' }}>
                    <Form
                        initValues={{
                            [`text${index}`]: danmaku.text,
                            [`fontSize${index}`]: danmaku.fontSize,
                            [`speed${index}`]: danmaku.speed || 10
                        }}
                        onValueChange={(values) => {
                            handleDanmakuChange(index, 'text', values[`text${index}`]);
                            handleDanmakuChange(index, 'fontSize', values[`fontSize${index}`]);
                            handleDanmakuChange(index, 'speed', values[`speed${index}`]);
                        }}
                    >
                        <div>
                            <div style={{ marginBottom: '12px' }}>
                                <div style={{ marginBottom: '8px' }}>弹幕文本 {index + 1}</div>
                                <SingleTextStyleForm
                                    data={{
                                        text: danmaku.text,
                                        style: {
                                            fontSize: `${danmaku.fontSize}px`,
                                            color: danmaku.textColor,
                                            backgroundColor: danmaku.backgroundColor
                                        }
                                    }}
                                    onChange={(newData) => {
                                        handleDanmakuChange(index, 'text', newData.text);
                                        handleDanmakuChange(index, 'fontSize', parseInt(newData.style.fontSize));
                                        handleDanmakuChange(index, 'textColor', newData.style.color);
                                        handleDanmakuChange(index, 'backgroundColor', newData.style.backgroundColor);
                                    }}
                                />
                            </div>
                            <div>
                                <div>
                                    <div style={{ marginBottom: "12px" }}>头像</div>
                                    <ImageSelector
                                        value={danmaku.avatar}
                                        onChange={(value) => handleDanmakuChange(index, 'avatar', value)}
                                        previewSize={32}
                                    />
                                </div>
                                <Form.InputNumber
                                    label="移动速度"
                                    field={`speed${index}`}
                                    style={{ width: '100%' }}
                                    suffix="秒"
                                    value={danmaku.speed}
                                    onChange={(value) => handleDanmakuChange(index, 'speed', value)}
                                />
                            </div>
                            {(data.danmakus || defaultData.danmakus).length > 1 && (
                                <Popconfirm
                                    title="确定要删除该弹幕吗？"
                                    onConfirm={() => removeDanmaku(index)}
                                >
                                    <Button
                                        type="danger"
                                        theme="borderless"
                                        icon={<IconDelete />}
                                        style={{ position: 'absolute', right: 0, top: '-5px' }}
                                    />
                                </Popconfirm>
                            )}
                        </div>
                    </Form>
                </div>
            ))}
            <Button icon={<IconPlus />} onClick={addDanmaku} theme="light" style={{ width: '100%' }}>
                添加弹幕
            </Button>
        </div>
    );
};

export default DanmakuStyleForm;
